import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children", "truncate", "visuallyHidden", "htmlFor", "use"];
import styled from 'foundations-theming/utils';
import { forwardRef } from 'react';
import { filterProps } from '../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../hooks/useMapTokenPropsToCSS';
import { TEXT_RESET_STYLES, TEXT_VISUALLY_HIDDEN_STYLES } from './Text.styles';
import { customizeStyles, generateTextTruncateStyles } from './Text.helpers';
import { useIsInFilledToolbar } from '../../transitional/components/ToolBar/ToolBarContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledText = styled.p.withConfig({
  displayName: "Text__StyledText"
})(({
  $truncate,
  $visuallyHidden,
  $cssStyles,
  $use,
  theme
}) => {
  const useToColor = {
    error: theme.color['text-alert-default'],
    help: theme.color['text-core-subtle'],
    success: theme.color['fill-positive-default'],
    disabled: theme.color['text-primary-disabled'],
    'on-dark': theme.color['text-core-on-fill-default'],
    'high-contrast': theme.color['text-core-on-fill-default'],
    default: undefined // Text has no color by default and will inherit
  };
  const useToBackground = {
    'high-contrast': theme.color['fill-accent-neutral-pressed'],
    'medium-contrast': theme.color['fill-surface-raised'],
    selected: theme.color['border-core-subtle'],
    default: undefined // Text has no background by default and will be transparent
  };
  return Object.assign({}, TEXT_RESET_STYLES, {
    color: $use ? useToColor[$use] : undefined,
    background: $use ? useToBackground[$use] : undefined
  }, $cssStyles, $truncate ? generateTextTruncateStyles($truncate) : {}, $visuallyHidden ? TEXT_VISUALLY_HIDDEN_STYLES : {});
});
export const Text = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      as = 'p',
      children,
      truncate,
      visuallyHidden,
      htmlFor,
      use = 'default'
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(restProps);
  const isInFilledToolbar = useIsInFilledToolbar();
  const cssStyles = useMapTokenPropsToCSS(tokenProps, {
    customizeStyles: opts => customizeStyles(as, opts, isInFilledToolbar)
  });
  const labelProps = htmlFor && as === 'label' ? {
    htmlFor
  } : {};
  return /*#__PURE__*/_jsx(StyledText, Object.assign({
    ref: ref
  }, domProps, labelProps, {
    as: as === 'h7' ? 'h2' : as,
    $truncate: truncate,
    $visuallyHidden: visuallyHidden,
    $cssStyles: cssStyles,
    $use: use,
    children: children
  }));
});
Text.displayName = 'Text';